<template>
  <transition>
    <a-layout-sider theme="light" :class="collapsed ? 'suspension sider' : 'sider'" :width="collapsed ? '34px' : '208px'">
      <div v-show="collapsed">
        <div class="m-header" @click="handleCollapse" style="cursor: pointer;">
          <xn-icon icon="homeRightShow" class="xn-icon icon" />
        </div>
      </div>
      <div v-show="!collapsed">
        <div class="header">
          <!-- <QuestionCircleOutlined :style="{ fontSize: '16px', color: '#888' }"/> -->
          <span class="title">使用帮助</span>
          <xn-icon icon="homeRightHide" class="xn-icon icon" @click="handleCollapse" />
        </div>
        <div class="content">
          <slot>
            <ul v-if="list?.length">
              <li v-for="o in list">
                <i></i>
                <a :href="o.href" target="_blank" class="xn-link">{{ o.title }}</a>
              </li>
            </ul>
          </slot>
        </div>
      </div>
    </a-layout-sider>
  </transition>
</template>

<script setup lang="ts">
import { ref } from 'vue'
// import { QuestionCircleOutlined } from '@ant-design/icons-vue'

interface LiItem {
  title: string
  href: string
}

interface Props {
  list: LiItem[]
}

defineProps<Props>()

const collapsed = ref(true)
const handleCollapse = () => {
  collapsed.value = !collapsed.value
}
</script>

<style lang="scss" scoped>
.suspension {
  height: 34px!important;
  border-radius: 17px;
  position: absolute;
  right: 10px;
  top: 14px;
  overflow: hidden;
  box-shadow: 0px 0px 1px 0px rgba(0, 0, 0, 0.08), 0px 1px 2px 0px rgba(25, 15, 15, 0.07), 0px 2px 4px 0px rgba(0, 0, 0, 0.05);
}
.sider {
  overflow-y: auto;
  box-shadow: 0px 1px 6px 0px rgba(0,0,0,0.05);
  .m-header {
    position: relative;
    height: 24px;
    margin: 5px auto;
    .icon {
      left: 50%;
      transform: translateX(-8px);
    }
  }
  .header {
    position: relative;
    height: 24px;
    margin: 14px 10px 14px 12px;
  }
  .title {
    font-weight: 600;
    font-size: 16px;
    color: rgba(0,0,0,0.85);
    line-height: 24px;
  }
  .icon {
    position: absolute;
    top: 4px;
    right: 0;
  }
  .content {
    border-top: 1px solid #E9E9E9;
    padding: 16px 12px;
    ul {
      padding-left: 0;
      li {
        line-height: 22px;
        margin-bottom: 12px;
        list-style: none;
        width: 180px;
        i {
          display: inline-block;
          width: 4px;
          height: 4px;
          vertical-align: top;
          margin-top: 10px;
          margin-right: 6px;
          border-radius: 10px;
          background: rgba(0,0,0,0.65);
        }
        a {
          display: inline-block;
          width: 168px;
          font-size: 12px;
          font-weight: 400;
          color: #006EFF;
        }
      }
    }
  }
}
</style>
